<template>
  <div :class="['google-sign-in', { 'google-sign-in--disabled': disabled }]">
    <p v-if="disabled" class="disabled-text">
      To sign in with Google, please
      <span style="font-weight: 700">allow this link to open in your default browser.</span>
    </p>
    <div id="g-signin2" class="google-button" @click="onGoogleButtonClick">
      <img src="../../assets/google-icon.svg" alt="Google icon" />
      <span class="google-text">Sign in with google</span>
    </div>
  </div>
</template>

<script>
import { getIOSVersion } from '@/utils'
import { GoogleAuth } from '@/types'

export default {
  name: 'google-login',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profile: null,
    }
  },
  mounted() {
    if (!this.isGoogleLoginDisabled) {
      this.initGoogleAuth()
    }
  },
  methods: {
    redirectToDefaultBrowser() {
      const currUrl = window.location.href
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const iosVersion = getIOSVersion(navigator.userAgent)
        if (!iosVersion) {
          return
        }
        window.location.href = `${
          iosVersion < 17 ? 'com-apple-mobilesafari-tab:' : 'x-safari-'
        }${currUrl}`
      } else if (/Android/i.test(navigator.userAgent)) {
        window.location.href = `intent://${currUrl.replace(/^https?:\/\//, '')}#Intent;scheme=http${
          currUrl.includes('https://') ? 's' : ''
        };action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
          currUrl,
        )};end`
      }
    },
    onSignIn(user) {
      const profile = user.getBasicProfile()
      const fullName = profile.getName()
      const email = profile.getEmail()
      const imageUrl = profile.getImageUrl()
      this.profile = { fullName, email, imageUrl }
      this.profile.googleTokenId = user.getAuthResponse().id_token
      this.$emit('userData', this.profile)
    },
    initGoogleAuth() {
      window.gapi.load(
        'auth2',
        function () {
          window.gapi.auth2
            .init({
              clientId: GoogleAuth.CLIENT_ID,
              plugin_name: GoogleAuth.PLUGIN_NAME,
            })
            .then(() => {
              if (!this.disabled) {
                window.gapi.auth2
                  .getAuthInstance()
                  .attachClickHandler('g-signin2', {}, this.onSignIn)
              }
            })
        }.bind(this),
      )
    },
    onGoogleButtonClick() {
      if (this.disabled) {
        this.redirectToDefaultBrowser()
      }
    },
  },
}
</script>
<style scoped>
p {
  margin: 0 8px;
}

.google-user {
  display: flex;
  align-items: center;
  width: 300px;
}

.profile-img {
  border-radius: 1000px;
  width: 30px;
  height: 30px;
}

.google-sign-in {
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 32px;
}

.google-button {
  cursor: pointer;
  text-transform: uppercase;
  width: fit-content;
  display: flex;
  padding: 4px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 24px;
  border: 2px solid rgba(151, 151, 151, 0.5);
}

@media screen and (max-width: 520px) {
  .google-button {
    border: 2px solid #f5f5f5;
    background: #f5f5f5;
  }
}

.google-text {
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.27px;
}

.google-sign-in--disabled {
  background-color: #f5f5f5;
}

.google-sign-in--disabled .google-button {
  background-color: white;
  border-width: 0;
}

.disabled-text {
  margin: 0;
  color: #666;
  text-align: center;
  font-family: 'Source Sans Pro';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
